/**
 * Created by yiren on 2019-08-29
 * API
 */

import ky from 'ky'
import {storeGet} from '../tool/lstool'
import {NET,MAINNET,TESTNET} from "./constant";

export const BaseUrl = {
    nas:
        storeGet(NET) === MAINNET
            ? 'https://mainnet.nebulas.io'
            : 'https://testnet.nebulas.io',
    nas_explorer:
        storeGet(NET) === MAINNET
            ? 'https://explorer.nebulas.io/#/'
            : 'https://explorer.nebulas.io/#/testnet/',
};



export const getAccountState = params => simplePost(`${BaseUrl.nas}/v1/user/accountstate`,params);

export const contractCall = params => simplePost(`${BaseUrl.nas}/v1/user/call`,params);

//////////////////////////////////////////// GET POST //////////////////////////////////////////////////////

export function simplePost(url,params) {
    return ky.post(url, {json: params}).json();
}

export function simpleGet(url) {
    return ky.get(url).json();
}